export function reorderWidgets<T extends { id: string }>(list: T[], fromId: string, toId: string): T[] {
  const from = list.findIndex((w) => w.id === fromId);
  const to = list.findIndex((w) => w.id === toId);
  if (from < 0 || to < 0 || from === to) {
    return list;
  }
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}
